const KitchenOrders = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-8">Pedidos en Cocina</h1>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold mb-4">Pendientes</h2>
            <p className="text-gray-600">Pedidos esperando preparación...</p>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold mb-4">En Preparación</h2>
            <p className="text-gray-600">Pedidos siendo preparados...</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default KitchenOrders
